import { all, call, put, takeLatest } from 'redux-saga/effects'
import { Types } from '../../types'
import {
  CallReportResponse,
  GetCallQueueReportResponse,
  GetUrlResponse,
} from '../../types/callReport/apiRequestTypes'
import {
  getCallQueueReport,
  getCallReport,
  getRecordUrlList,
} from '../apiRequests/callReportRequest'
import {
  callQueueReportErrorAction,
  callQueueReportSuccessAction,
  callReportErrorAction,
  callReportNameErrorAction,
  callReportNameSuccessAction,
  callReportSuccessAction,
  getUrlErrorAction,
  getUrlSuccessAction,
} from '../../actions/callReportActions'
import { AnyCnameRecord } from 'dns'

function* getCallReportHandler(action: any) {
  try {
    const response: { data: CallReportResponse } = yield call(getCallReport, action.payload)
    yield put(
      callReportSuccessAction({
        params: response.data,
      }),
    )
  } catch (error: any) {
    yield put(
      callReportErrorAction({
        error: error,
      }),
    )
  }
}

function* getCallReporNametHandler(action: any) {
  try {
    const response: { data: any } = yield call(getCallReport, action.payload)
    yield put(
      callReportNameSuccessAction({
        params: response.data,
      }),
    )
  } catch (error: any) {
    yield put(
      callReportNameErrorAction({
        error: error,
      }),
    )
  }
}

function* getCallQueueReportHandler(action: any) {
  try {
    const response: { data: GetCallQueueReportResponse } = yield call(
      getCallQueueReport,
      action.payload?.recordName,
    )
    yield put(
      callQueueReportSuccessAction({
        params: response.data,
      }),
    )
  } catch (error: any) {
    yield put(
      callQueueReportErrorAction({
        error: error,
      }),
    )
  }
}

function* getRecordUrlListHandler(action: any) {
  try {

    const response: { data: GetUrlResponse } = yield call(
      getRecordUrlList,
      action.payload,
    )
    yield put(
      getUrlSuccessAction({
        params: response.data,
      }),
    )
  } catch (error: any) {
    yield put(
      getUrlErrorAction({
        error: error,
      }),
    )
  }
}

function* callReportSaga() {
  yield all([takeLatest(Types.GET_CALL_REPORT_REQUEST, getCallReportHandler)])
  yield all([takeLatest(Types.GET_CALL_QUEUE_REPORT_REQUEST, getCallQueueReportHandler)])
  yield all([takeLatest(Types.GET_RECORD_URL_LIST_REQUEST, getRecordUrlListHandler)])
  yield all([takeLatest(Types.GET_CALL_REPORT_NAME_REQUEST, getCallReporNametHandler)])
}

export default callReportSaga
